import { StyledTypography } from '../StyledComponents';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { DictDocumentType, getDateOfBirthFromPESEL } from '../../../Helpers/Constants';
import { styled } from '@mui/material';
import { formatShortDate } from '../../../Helpers/Format/localeFormat';

const Typography = styled(StyledTypography)({
	marginBottom: 0,
});

export const TenantPersonalData = () => {
	const { t } = useTranslation('common');
	const { watch } = useFormContext();

	const formFields = {
		documentType: watch('documentType') as DictDocumentType,
		isCompany: watch('isCompany') as boolean,
		pesel: watch('pesel') as string,
		companyName: watch('companyName') as string,
		vatCountryCode: watch('vatCountryCode') as string,
		ein: watch('ein') as string,
		dateOfBirth: watch('birthdate') as string,
		firstName: watch('firstName') as string,
		lastName: watch('lastName') as string,
		email: watch('email') as string,
	};

	const formattedName = `${formFields.firstName} ${formFields.lastName}`;

	const sensitiveData = useMemo(() => {
		let firstLine = '';
		let secondLine = '';

		const setPrivateTenantData = () => {
			const birthdate = formFields.dateOfBirth;
			let dob = birthdate ? formatShortDate(birthdate) : '';

			const isPolishPesel =
				formFields.documentType === DictDocumentType.IDCard ||
				(Number(formFields.documentType) === DictDocumentType.PersonalIdNumber &&
					/^\d{11}$/.test(formFields.pesel ?? ''));

			if (isPolishPesel && !dob) dob = getDateOfBirthFromPESEL(formFields.pesel);

			firstLine = `${t('insurance.bornAbbr')} ${dob}`;
		};

		const setCompanyData = () => {
			const formattedEin =
				formFields.vatCountryCode === 'PL' ? formFields.ein : `${formFields.vatCountryCode}${formFields.ein}`;

			firstLine = `${t('form.companyName')}: ${formFields.companyName}`;
			secondLine = formattedEin ? `${t('form.EIN')}: ${formattedEin}` : '';
		};

		if (formFields.isCompany) setCompanyData();
		else setPrivateTenantData();

		return { firstLine, secondLine };
	}, [formFields]);

	return (
		<>
			<Typography text={formattedName} element={'body1'} bold />
			<Typography text={sensitiveData.firstLine} element={'body2'} />
			{!!sensitiveData.secondLine && <Typography text={sensitiveData.secondLine} element={'body2'} />}
			<Typography text={formFields.email} element={'body2'} />
		</>
	);
};
